// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2d3524b1","453":"40cd9aed","455":"bd89162f"}[chunkId] + ".chunk.js";
};